import Immutable from 'seamless-immutable';
import voca from 'voca';

const pushToArrayProp = (obj, path, values) => obj.updateIn(Array.isArray(path) ? path : [path], (arr) => arr.concat(values));

const spliceArray = (arr, index, count, ...items) => {
  arr = arr.asMutable();
  arr.splice(index, count, ...items);
  return arr;
};

const spliceArrayProp = (obj, path, index, count = 1, ...items) =>
  obj.updateIn(Array.isArray(path) ? path : [path], (arr) => spliceArray(arr, index, count, ...items));

const filterArrayProp = (obj, path, filterFn) => obj.updateIn(Array.isArray(path) ? path : [path], (arr) => arr.asMutable().filter(filterFn));

const isEmpty = (obj) => (obj === null || obj === undefined || Array.isArray(obj) ? obj.length === 0 : voca.isString(obj) && voca.isBlank(obj));

const withoutIn = (obj, path, toRemove, ...args) => {
  path = Array.isArray(path) ? path : isEmpty(path) ? null : [path];
  toRemove = Array.isArray(toRemove) ? toRemove.concat(args) : [toRemove].concat(args);

  const updater = (val) => Immutable.without(val, toRemove);

  return isEmpty(path)
    ? Immutable.without(obj, toRemove)
    : path.length > 1
    ? obj.setIn(path, obj.updateIn(path, updater))
    : obj.set(path[0], updater(obj[path[0]]));
};

export { pushToArrayProp, spliceArray, spliceArrayProp, filterArrayProp, withoutIn };
